import { posAxiosClient } from '@kinderlabs-pos/apis/axios';

export const deleteWarehouseOrderFileInfoAsync =
	(rootUrl: string) =>
	async ({ orderId, fileId }: { orderId: number; fileId: number }) =>
		(
			await posAxiosClient.delete(`${rootUrl}/warehouse-order/file`, {
				params: {
					orderId,
					fileId,
				},
			})
		).data;
